import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Subheader } from 'material-ui';
import { removeAreaChild } from 'actions/regions/areas';
import PortsAreasToggler from '../PortsAreasToggler';
import AreaList from './AreaList';

function selectParentAreasOf(areaId) {
    return state => state.areas.items.filter(a => a.childs && a.childs.includes(areaId));
}

function selectChildAreasOf(areaId) {
    return state => state.areas.items.filter(a => a.parents && a.parents.includes(areaId));
}

function Areas({
    area,
    parents,
    childAreas,
    toggleShowPorts,
    toggleShowAreas,
    showChilds,
    selectParentArea,
    isUpdating,
    allAreas,
    removeAreaChild,
}) {
    const handleRemoveChildArea = (childId) => {
        removeAreaChild(area._id, childId);
    };

    const handleRemoveParentArea = (parentId) => {
        removeAreaChild(parentId, area._id);
    };

    return (
        <React.Fragment>
            <div className='row'>
                <div className='col-xs-3 col-xs-offset-9'>
                    <PortsAreasToggler 
                        toggleShowPorts={toggleShowPorts}
                        toggleShowAreas={toggleShowAreas}
                        showChilds={showChilds}
                    />
                </div>
            </div>
            <div className='paper-block margin-9'>
                <span className='name-block absolute small-name'>
                    Areas related to {area.name || 'selected one'}
                </span>
                <div style={{ overflowY: 'scroll', height: '75vh', width: '100%' }}>
                    <Subheader>Parents</Subheader>
                    <AreaList
                        areas={isUpdating ? null : parents}
                        allAreas={allAreas}
                        onAreaClick={selectParentArea}
                        onRemoveClick={handleRemoveParentArea}
                        emptyText="No parent areas"
                    />
                    <Subheader>Children</Subheader>
                    <AreaList
                        areas={isUpdating ? null : childAreas}
                        allAreas={allAreas}
                        onAreaClick={selectParentArea}
                        onRemoveClick={handleRemoveChildArea}
                        emptyText="No subregions"
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default React.memo(connect(
    /**
     * @param {*} state 
     * @param {*} props
     */
    (state, props) => ({
        parents: selectParentAreasOf(props.area._id)(state),
        childAreas: selectChildAreasOf(props.area._id)(state),
        isUpdating: state.areas.isUpdating,
        allAreas: state.areas.items,
    }),
    dispatch => bindActionCreators({
        removeAreaChild,
    }, dispatch),
)(Areas));


// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Areas/Areas.jsx